var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eu-nav-switch-trigger",on:{"click":_vm.onNavFold}},[_c('i',{staticClass:"el-icon-arrow-left"})])
}
var staticRenderFns = []

export { render, staticRenderFns }